import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import fbConfig from '../../../../../config/firebaseConfig'
import LinearProgress from '@material-ui/core/LinearProgress'
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import cuid from 'cuid'


const styles = theme => ({
  root: {
    margin: '24px '
  },
  form: {
     margin: '0px',
  },
  submit: {
     marginTop:'24px',
  },
  title : {
     fontSize: '1rem',
      marginBottom: '12px',
      textTransform: 'uppercase'
  },
  nameHolder: {
      display: 'block',
      marginTop:'46px',
  },
  linearColorPrimary: {
    backgroundColor: 'transparent',
  },
  linearBarColorPrimary: {
    backgroundColor: 'white',
  },
  info: {
      width: '100%',
      maxWidth: '400px',
      textAlign: 'center'
  }
});

 
 class WriteMessage extends Component {
        constructor(props){
            super(props);
            this.state = {
                name: '',
                companyId: '',
                sendMessageTo: '',
                message: '',
                role:'',
                loading: false,
                msgFrom:'',
                msgFromId:'',
                time: '',
                disabled: true
            }
        }
        handleChange = (e) => {
            this.setState({
                ...this.state,
            message: e.target.value
            })  
            this.handleCaracters() 
        }
        handleCaracters = () => {
            let count = this.state.message
            //console.log(count)
            let broj = count.length
            //console.log(broj)
            if(broj >= 2){
               // console.log('veci od dva')
                this.setState({
                    //...this.state,
                    disabled: false
                })
             } else {
                // console.log('manji od dva')
                this.setState({
                    //...this.state,
                    disabled: true
                })
            }
        }
        handleSubmit = (e) => {
            e.preventDefault();
            this.setState({
                ...this.state,
                loading: true
            })
            
            this.sendMessage();
        }
        sendMessage = () => {
            //console.log('message send')
            this.setState({
            ...this.state,
            loading: true
            })
            var d = new Date();
            var year = d.getFullYear();
            var day = d.getDate();
            var hours = d.getHours();
            if(hours.length === 1){
                hours = '0'+ hours
            }
            var minutes = d.getMinutes();
            if(minutes.length === 1){
                minutes = '0'+ minutes
            }
            const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
    ];
            let date = day +' '+ monthNames[d.getMonth()] +' '+ year 
            let time = hours +':'+ minutes
            let companyId = this.state.companyId
            let role = this.state.role
            let sendMessageTo = this.state.sendMessageTo
            let messageId = cuid()
            //Firebase connection
            const db = fbConfig.firestore();
            // let userId = this.props.auth;

            db.collection(companyId).doc('companyUsers').collection(role+'s').doc(sendMessageTo).collection('notifications').doc(messageId)
            .set({
                from: this.state.msgFrom,
                fromId: this.state.msgFromId,
                message: this.state.message,
                time,
                date,
                status: 'unread',
                messageId: messageId
            })
            .then(result => {          
                this.setState({
                    ...this.state,
                    loading: false,
                    status: 'send',
                    disabled: true
                
                })
            })
            .catch(err => {
            //console.log(err);
                this.setState({
                ...this.state,
                messageErr: err.message,
                loading: false,
                })
            });
        }
        componentDidMount = () => {
            this.setState({
                name: this.props.name,
                companyId: this.props.profile.companyId,
                sendMessageTo: this.props.sendMessageTo,
                role: this.props.role,
                message: '',
                msgFrom: this.props.profile.name,
                msgFromId: this.props.profile.id
            })
        }
  render() {
    const { classes } = this.props;
    //console.log('WM PROPS', this.props)
    //console.log('WM STATE', this.state)
    return (
        <div> 
            <div className={classes.root}>
            <div className={classes.nameHolder}>
                    <Typography  className={classes.title}>
                        Send Message to {this.props.name}
                    </Typography> 
                </div>
                <Divider/>  
                <form
                    ref="form"
                    onSubmit={this.handleSubmit}
                    onError={errors => console.log(errors)} 
                    className={classes.form}
                    id='trainerForm'
                >
                <TextField
                    fullWidth
                    id="message"
                    label="Message"
                    multiline
                    rows="3"
                    placeholder="Type message text here"
                    onChange={this.handleChange}
                    className={classes.textField}
                    margin="normal"
                    inputProps={{ maxLength: 146}}
                />
                    <Button 
                        type="submit"
                        fullWidth
                        variant="contained"
                        className={classes.submit}
                        style={{color: sessionStorage.buttonColor, background: sessionStorage.buttonBgColor}}
                        disabled={ this.state.disabled}
                    >
                            Send Message
                    </Button>
                    <div style={{height: '30px', width:'100%', marginTop: '-3px'}}>
                    { this.state.loading === true ? 
                        <LinearProgress 
                        classes={{
                        colorPrimary: classes.linearColorPrimary,
                        barColorPrimary: classes.linearBarColorPrimary,
                        }} 
                        style={{width: '100%'}}/>
                        : "" 
                    }
                    
                </div>
               
                    { this.state && this.state.status === 'send' ?
                        <Typography className={classes.info} variant="subheading">Message send</Typography>
                        : ''
                    } 
              
                </form>
                 
            </div>
      </div>
    )
  }
}

WriteMessage.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
    return {
        profile: state.firebase.profile
    }
}
export default withStyles(styles)(connect(mapStateToProps, null)(WriteMessage))
